var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('article',{staticClass:"ec-container"},[_c('div',{staticClass:"main_wrapper"},[_c('router-view',{key:_vm.componentKey})],1)]),_c('Footer'),_c('BackTop',{attrs:{"bottom":50}}),(_vm.isLoading)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }